import { GetSexualCompatibilityStatusResponse } from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/compatibility/v1/compatibility_api_pb';

import { ExtractClassFields } from '@/type';

export type SexualCompatibilityState = {
  compatibilityStatuses: {
    [key: string]: ExtractClassFields<GetSexualCompatibilityStatusResponse>;
  };
};

export const state: SexualCompatibilityState = {
  compatibilityStatuses: {},
};
